{
    "Policies_Bordereaux.title": "Bordereaux",
    "Policies_Bordereaux.filter.product": "Product",
    "Policies_Bordereaux.filter.selectProduct": "Please select a product",
    "Policies_Bordereaux.table.product": "Product",
    "Policies_Bordereaux.table.year": "Year",
    "Policies_Bordereaux.table.month": "Month",
    "Policies_Bordereaux.table.count": "Count",
    "Policies_Bordereaux.table.download": "Download",
    "Policies_Bordereaux.noData": "No bordereau data available for the selected product"
}
